export default __webpack_public_path__ + "static/software.stack.balance-bf6a9809db6b3dccfd9d11e75937325d.jpg";